import { ContactSupportContainer } from '../../../contact-support/ContactSupportContainer'

export const Support = () => {
  return <ContactSupportContainer />
}
